import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Switch } from 'components/ds/Choice'
import { Toast } from 'components/shared/Toaster'
import strings from 'strings'
import { setMonitoringNotifyMe } from 'actions/monitoring'

const S = strings.MONITORINGS

// "Notify me" for one monitor (advanced monitoring): the current user turns their own alerts (email and in-app)
// on or off. Saves immediately, independent of the setup form's Save. Shows who set up the monitor. Greyed out
// while the user has paused all their monitoring alerts in their profile.
const MonitoringNotifyMe = ({ applicationId, notifyMe, requesterName, alertsPaused = false }) => {
    const [on, setOn] = useState(!!notifyMe)
    const [saving, setSaving] = useState(false)
    useEffect(() => { setOn(!!notifyMe) }, [notifyMe])

    const change = (next) => {
        setOn(next)
        setSaving(true)
        setMonitoringNotifyMe(applicationId, next)()
            .then(() => Toast({ type: 'success', message: next ? S.NOTIFY_ME_ON : S.NOTIFY_ME_OFF }))
            .catch(() => setOn(!next)) // the request helper already shows the error
            .finally(() => setSaving(false))
    }

    return (
        <div className='monSetup__notifyMe'>
            <Switch label={S.NOTIFY_ME} checked={on && !alertsPaused} disabled={saving || alertsPaused}
                onChange={(e) => change(e.target.checked)} />
            {alertsPaused ? (
                <div className='monSetup__notifyMeHint'>
                    {S.ALERTS_PAUSED} <Link to='/profile?tab=notifications'>{S.ALERTS_PAUSED_LINK}</Link>
                </div>
            ) : requesterName && (
                <div className='monSetup__notifyMeHint'>{S.SET_UP_BY.replace('{name}', requesterName)}</div>
            )}
        </div>
    )
}

export default MonitoringNotifyMe
